import React from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from 'react';
import { LanguageLoader } from '../../../assets/languages';
import Table from './../../../components/features/Table';
import { CallCustomAPI, FetchDropdownAPI } from "../../../services/index.js";
import Relate from "../../../components/features/Relate.jsx";
import Dropdown from "../../../components/features/Dropdown.jsx";
import Attachments from "../../../components/features/Attachments";
import { toast } from 'react-toastify';

const CSROLL_MassCreateCases = () =>
{
	const preferences = useSelector((state) => state.preferences);
	const language = LanguageLoader(preferences.language);
	const navigate = useNavigate();
	const [dataEntry, SetDataEntry] = useState([]);
	const [dropdowns, SetDropdowns] = useState({});

	let vardefs = {
		'account_id': {
			name: 'account_id',
			label: {'fa_IR': 'نام حساب', 'en_US': 'Account name'},
			module: 'Accounts',
			see_more: false,
		},
		'status': {
			name: 'status',
			label: {'fa_IR': 'وضعیت', 'en_US': 'Status'},
			options: {},
		},
		'team_id': {
			name: 'team_id',
			label: {'fa_IR': 'نام تیم', 'en_US': 'Team name'},
			module: 'team',
			see_more: false,
		},
		'product_id': {
			name: 'product_id',
			label: {'fa_IR': 'نام محصول *', 'en_US': 'Product name *'},
			module: 'AOS_Products',
			see_more: false,
		},
		'service_serial': {
			name: 'service_serial',
			label: {'fa_IR': 'شماره سریال *', 'en_US': 'Service serial *'},
		},
		'service_number': {
			name: 'service_number',
			label: {'fa_IR': 'تعداد *', 'en_US': 'Qty *'},
			options: {},
		},
		'service_tonnage': {
			name: 'service_tonnage',
			label: {'fa_IR': 'تناژ نورد شده با غلتک', 'en_US': 'Tonnage'},
			options: {},
		},
		'service_standnum': {
			name: 'service_standnum',
			label: {'fa_IR': 'شماره استند', 'en_US': 'Stand Number'},
			options: {},
		},
		'service_period': {
			name: 'service_period',
			label: {'fa_IR': 'کارکردغلتک (تعداد پریود)', 'en_US': 'Period'},
			options: {},
		},
		'service_diameter': {
			name: 'service_diameter',
			label: {'fa_IR': 'قطر غلتک زمان بروز مشکل', 'en_US': 'Diameter'},
			options: {},
		},
		'type': {
			name: 'type',
			label: {'fa_IR': 'عیب *', 'en_US': 'Type *'},
			options: {},
		},
		'description': {
			name: 'description',
			label: {'fa_IR': 'توضیحات *', 'en_US': 'Description *'},
		},
		'attachment': {
			name: 'attachment',
			label: {'fa_IR': 'فایل ضمیمه', 'en_US': 'Attachment'},
		}
	};


	const headers = {
		'product_id': vardefs.product_id.label[preferences.language],
		'service_serial': vardefs.service_serial.label[preferences.language],
		'service_number': vardefs.service_number.label[preferences.language],
		'service_tonnage': vardefs.service_tonnage.label[preferences.language],
		'service_standnum': vardefs.service_standnum.label[preferences.language],
		'service_period': vardefs.service_period.label[preferences.language],
		'service_diameter': vardefs.service_diameter.label[preferences.language],
		'type': vardefs.type.label[preferences.language],
		'description': vardefs.description.label[preferences.language],
		'attachment': vardefs.attachment.label[preferences.language],
		'delete': ''
	};
	useEffect(() =>
	{
		FetchInitialData();
		// eslint-disable-next-line
	}, []);


	const FetchInitialData = async () => {
		const statusDropdown = await FetchDropdownAPI({key: 'case_status_dom'});
		const typeDropdown = await FetchDropdownAPI({key: 'case_type_dom'});
		const initialData = {
			'status': statusDropdown,
			'type': typeDropdown,
		};
		SetDropdowns(initialData);
	}

	const DoSave = async () =>
	{
		if(dataEntry.length > 0)
		{
			if (checkRequiredFields() && checkForDuplicates())
			{
				console.log('dataEntrydataEntrydataEntrydataEntry');
				console.log(dataEntry);
				const APIResponse = await CallCustomAPI("MassCreateCases", dataEntry);
				if(APIResponse['result'])
				{
					setTimeout(function() {
						window.location.replace('/dynamic/MassCreateCases/');
					}, 2000);
				}
			}
		}
		else
		{
			toast.error("دیتای برای ذخیره ایجاد نشده است");
		}
	}

	const checkForDuplicates = () => {
		const seen = new Set();
		for (const entry of dataEntry)
		{
			const key = `${entry.product_id}-${entry.type}`;
			if (seen.has(key))
			{
				toast.error("محصول با عیب تکراری یافت شد");
				return false;
			}
			seen.add(key);
		}
		return true;
	};

	const checkRequiredFields = () => {
		for (let i = 0; i < dataEntry.length; i++)
		{
			const entry = dataEntry[i];
			if (entry.description.trim() === "" || entry.product_id.trim() === "" || entry.service_serial.trim() === "" || entry.type.trim() === "")
			{
				toast.error(`فیلدهای اجباری در ردیف ${i + 1} کامل نشده‌اند`);
				return false;
			}
		}
		return true;
	};

	const AddLineItem = () =>
	{
		const items = [...dataEntry];
		const templateData = {'product_id': '', 'service_serial': '', 'service_number': '', 'service_tonnage': '', 'service_standnum': '', 'service_period': '', 'service_diameter': '', 'type': '', 'description': ''};
		items.push(templateData);
		SetDataEntry(items);
	}

	const RemoveLineItem = (index) => {
		const items = [...dataEntry];
		items.splice(index, 1);
		SetDataEntry(items);
	}

	const HandleLineItemChange = (index, key, value) =>
	{
		const integers = [ 'service_number', 'service_serial' ];
		if(integers.includes(key))
		{
			value = value.replace(/[^0-9.]/g, '');
		}
		const items = [...dataEntry];
		if(key === "attachment")
		{
			if(value[0] && value[0]["id"])
			{
				items[index][key] = value[0]["id"];
			}
		}
		else
		{
			items[index][key] = value;
		}
		SetDataEntry(items);
	}

	return <>
		<div className='title flex justify-between w-full'>
			<h6>&nbsp;</h6>
			<div className="flex">
				<Link onClick={() => navigate(-1)} className="btn btn-secondary">{language.CANCEL}</Link>
				<button onClick={DoSave} type='button' className="btn-primary">{language.SAVE}</button>
			</div>
		</div>
		<div className="flex flex-wrap">
			<div className="flex flex-col w-full">
				<div className='title flex justify-between w-full'>
					<i className="py-4 px-2 mx-1 fa fa-plus fa-lg bg-primary text-white rounded-md cursor-pointer" onClick={AddLineItem}></i>
				</div>
				<Table className='mt-4 overflow-auto' header={headers}>
					{dataEntry && dataEntry.map((item, index) => {
						let defaultRelateValue = {'id': "", 'name': ""};
						return <tr key={index}>
							<td className="w-1/12">
								<Relate vardef={vardefs.product_id} value={dataEntry[index]['product_id'] ?? ''} defaultValue={defaultRelateValue} onChange={value => HandleLineItemChange(index, 'product_id', value.id)}/>
							</td>
							<td className="w-1/12">
								<input type="text" onChange={(e) => HandleLineItemChange(index, 'service_serial', e.target.value)} value={dataEntry[index]['service_serial'] ?? ''}/>
							</td>
							<td className="w-1/12">
								<input type="text" onChange={(e) => HandleLineItemChange(index, 'service_number', e.target.value)} value={dataEntry[index]['service_number'] ?? ''}/>
							</td>
							<td className="w-1/12">
								<input type="text" onChange={(e) => HandleLineItemChange(index, 'service_tonnage', e.target.value)} value={dataEntry[index]['service_tonnage'] ?? ''}/>
							</td>
							<td className="w-1/12">
								<input type="text" onChange={(e) => HandleLineItemChange(index, 'service_standnum', e.target.value)} value={dataEntry[index]['service_standnum'] ?? ''}/>
							</td>
							<td className="w-1/12">
								<input type="text" onChange={(e) => HandleLineItemChange(index, 'service_period', e.target.value)} value={dataEntry[index]['service_period'] ?? ''}/>
							</td>
							<td className="w-1/12">
								<input type="text" onChange={(e) => HandleLineItemChange(index, 'service_diameter', e.target.value)} value={dataEntry[index]['service_diameter'] ?? ''}/>
							</td>
							<td className="w-1/12">
								<Dropdown onChange={(value) => HandleLineItemChange(index, 'type', value)} multiple={false} options={dropdowns.type ? dropdowns.type : {}}/>
							</td>
							<td className="w-auto">
								<textarea rows={1} className="!transition-none !delay-0" onChange={(e) => HandleLineItemChange(index, 'description', e.target.value)}></textarea>
							</td>
							<td className="w-auto">
								<Attachments types='file' single={true} onChange={(e) => HandleLineItemChange(index, 'attachment', e)}/>
							</td>
							<td className="text-end"></td>
						</tr>
					})}
				</Table>
			</div>
		</div>
	</>
}

export default CSROLL_MassCreateCases;